import { render } from "./Artist.vue?vue&type=template&id=6629bbf3"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/samuelquaresma/Documents/Dev/DAF/app-capacitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__